export default __webpack_public_path__ + "static/media/burger.d08e6bd1.svg";